<template>
    <div class="pt-15 animated fadeIn equipmentList bgV2">
        <div class="boxShadow setBorderRadius heig-frame-equipment-group">
            <b-row no-gutters>
                <b-col md="12" class="heig-frame-child">
                    <gofix-card class="mb-0 heig-frame-child" fullContent>
                        <gofix-default-table :settings="tableConfig"
                            :table-items="tableItems"
                            @load-items="getTableData"
                            @row-click="clickToRowItem"
                            @new-item="newItem"
                            @delete-items="deleteItems"
                            @export="exportItems"
                            ref="gofixTable">
                            <template slot="gofix_table:planned_date" slot-scope="row">
                                {{row.item.started_date | formatDatebyMoment("YYYY-MM-DD","DD.MM.YYYY")}}
                            </template>
                        </gofix-default-table>
                    </gofix-card>
                </b-col>
            </b-row>
        </div>

        <b-modal 
            :no-close-on-backdrop="true" 
            id="modal-Create"
            title="Add Toolbox Meeting" 
            hide-footer 
            :centered="true" 
            v-model="modals.add.open">
            <template>
                <b-row class="mb-16">
                    <b-col md="12">
                        <gofix-form-dropdown
                            vLabel="contract_reference_number"
                            label="Project" 
                            :filterable="false" 
                            :required="true"
                            :show-icon-required="true"
                            :options="modals.add.options.scontracts"
                            @search="searchContract"
                            v-model="modals.add.data.project" 
                            @change="changeProject">
                            <template slot="gofixInput:dropdown:selected-option" slot-scope="option">
                                <span>{{ option.contract_reference_number || '--' }}</span>
                            </template>
                            <template slot="gofixInput:dropdown:option" slot-scope="option">
                                <span>{{ option.contract_reference_number || '--' }}</span>
                            </template>
                        </gofix-form-dropdown>
                        <gofix-form-dropdown
                            label="Locations"
                            v-model="modals.add.data.locations"
                            vLabel="tag_name"
                            :required="true"
                            :show-icon-required="true"
                            multiple
                            :options="modals.add.options.equipments"
                            @search="searchEquipment"
                            :clearable="false" 
                            :filterable="false">
                            <template slot="gofixInput:dropdown:selected-option" slot-scope="option">
                                <template v-if="option.lift_name">
                                    {{ option.lift_name ? `Lift ${option.lift_name}` : '' }}{{ option.location_name ? ` - ${option.location_name}` : '' }}
                                </template>
                                <template v-else>
                                    {{ option.location_name ? `${option.location_name}` : '' }}
                                </template>
                            </template>
                            <template slot="gofixInput:dropdown:option" slot-scope="option">
                                <template v-if="option.lift_name">
                                    {{ option.lift_name ? `Lift ${option.lift_name}` : '' }}{{ option.location_name ? ` - ${option.location_name}` : '' }}
                                </template>
                                <template v-else>
                                    {{ option.location_name ? `${option.location_name}` : '' }}
                                </template>
                            </template>
                        </gofix-form-dropdown>
                        <gofix-form-dropdown
                            label="Conducted At"
                            v-model="modals.add.data.equipment"
                            vLabel="tag_name"
                            :required="true"
                            :show-icon-required="true"
                            :options="modals.add.options.equipments"
                            @search="searchEquipment"
                            :clearable="false" 
                            :filterable="false">
                            <template slot="gofixInput:dropdown:selected-option" slot-scope="option">
                                <template v-if="option.lift_name">
                                    {{ option.lift_name ? `Lift ${option.lift_name}` : '' }}{{ option.location_name ? ` - ${option.location_name}` : '' }}
                                </template>
                                <template v-else>
                                    {{ option.location_name ? `${option.location_name}` : '' }}
                                </template>
                            </template>
                            <template slot="gofixInput:dropdown:option" slot-scope="option">
                                <template v-if="option.lift_name">
                                    {{ option.lift_name ? `Lift ${option.lift_name}` : '' }}{{ option.location_name ? ` - ${option.location_name}` : '' }}
                                </template>
                                <template v-else>
                                    {{ option.location_name ? `${option.location_name}` : '' }}
                                </template>
                            </template>
                        </gofix-form-dropdown>
                        <gofix-form-dropdown 
                            label="Topics" 
                            vLabel="reference_value_text"
                            required
                            show-icon-required
                            multiple
                            v-model="modals.add.data.topics" 
                            :options="modals.add.options.topics">
                        </gofix-form-dropdown>
                        <gofix-form-supplier
                            label="Subcontractor"
                            :contract-id="ClientContractID && ClientContractID.id ? ClientContractID.id : null"
                            :required="true"
                            v-model="modals.add.data.company">
                        </gofix-form-supplier>

                        <gofix-form-dropdown
                            label="Contractor Supervisor"
                            vLabel="user_name"
                            @search="searchContractorSupervisors"
                            :filterable="false"
                            v-model="modals.add.data.contractor_supervisor_by"
                            :options="modals.add.options.contractor_supervisors">
                            <template slot="gofixInput:dropdown:option"  slot-scope="option">
                                {{option.user_name}} - {{option.user_email}}
                            </template>
                            <template slot="gofixInput:dropdown:selected-option"  slot-scope="option">
                                {{option.user_name}} - {{option.user_email}}
                            </template>
                        </gofix-form-dropdown>

                        <gofix-form-input-date
                            :minDate="new Date()"
                            required
                            show-icon-required
                            v-model="modals.add.data.planned_date"
                            label="Date">
                        </gofix-form-input-date>
                        <b-row>
                            <b-col md="6">
                                <gofix-form-input-time 
                                    label="Start Time" 
                                    required
                                    show-icon-required
                                    v-model="modals.add.data.start_time">
                                </gofix-form-input-time>
                            </b-col>
                            <b-col md="6">
                                <gofix-form-input-time 
                                    label="End Time" 
                                    required
                                    show-icon-required
                                    v-model="modals.add.data.end_time">
                                </gofix-form-input-time>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row> 
            </template>
            <b-button-group class="d-block text-right pr-4">
                <gofix-button label="APPLY" @click="save" :disabled="modals.add.loading" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
    </div>
</template>

<script>
import { filters } from '@/_filterVar.js'
import moment from 'moment';
export default {
    name: 'toolbox-meeting-listing',
    data() {
        let filter = JSON.parse(JSON.stringify(filters['toolbox_meeting_listing']));
        return {
            tableConfig:{
                name: 'safety-toolbox-meeting-listing',
                controls:{
                    create: this.$checkRole(this.$accessModule.toolbox_meeting, 'create'),
                    delete: this.$checkRole(this.$accessModule.toolbox_meeting, 'delete')
                },
                filter: filter,
                page: 1,
                limit: 100,
                total: 0,
                sortColumn: "created_at",
                sortDirection: "desc",
                dataSelect: {
                    status: {
                        value: [
                            {value: 'New', text: 'New'},
                            {value: 'Submitted', text: 'Submitted'},
                            {value: 'Rejected', text: 'Rejected'},
                        ],
                        value_field: 'value',
                        text_field: 'text'
                    }
                },
            },
            tableItems: [],
            modals: {
                add: {
                    open: false,
                    loading: false,
                    data: {
                        project: null,
                        equipment: null,
                        checklist_template_id: null,
                        planned_date: null,
                        start_time: null,
                        end_time: null,
                        company: null,
                        contractor_supervisor_by: null,
                        topics: null,
                        locations: null
                    },
                    options: {
                        scontracts: [],
                        equipments: [],
                        users: [],
                        topics: [],
                        contractor_supervisors: []
                    }
                }
            },
            pagesEquipment: {
                isCMS: '1',
                limit: 100,
                page: 1,
                totalPage: 0,
                filter: JSON.parse(JSON.stringify(filters['equipment']))
            },
            timer: {
                equipment: null,
                scontracts: null,
                save: null
            },
        }
    },
    computed: {
        // Add computed properties here
    },
    methods: {
        async getTableData(callback) {
            // Handle loading table data
            try {
                const { tableRequest , resolve,reject } = await callback();
                await this.$store.dispatch("SafetyAppController/getSafetyToolboxMeetingItems", tableRequest)
                    .then(response => {
                        this.tableItems = response.items;
                        this.tableConfig.total = response.total;
                        resolve(response);
                    })
                    .catch(err => {
                        this.$alertNotification("Can not load list", "danger");
                        reject();
                    })
            } catch (error) {
                console.error('Error fetching table data:', error)
            }
        },
        changeProject() {
            this.modals.add.options.contractor_supervisors = [];
            this.modals.add.data.contractor_supervisor_by = null;
            if(this.modals.add.data.project && this.modals.add.data.project.id) {
                this.getContractorSupervisors();
            }
        },
        clickToRowItem(item) {
           this.$router.push(`/v2/toolbox-meeting/${item.id}`)
        },
        newItem() {
            if(!this.ClientContractID || !this.ClientContractID.id) {
                return this.$alertNotification("Please select a contract before create toolbox meeting.", "warning");
            }
            this.getSContracts();
            this.getEquipments();
            this.loadUser(100);
            this.getTopics();
            this.modals.add.data = {
                project: null,
                equipment: null,
                checklist_template_id: null,
                date: null,
                start_time: null,
                end_time: null,
                company: null,
                contractor_supervisor_by: null,
                topics: null
            };
            this.modals.add.open = true;
        },
        async deleteItems(callback){
            const { ids,filter, resolve,reject } = await callback();
            this.$store.dispatch("SafetyAppController/deleteSafetyToolboxMeetingItem", ids)
            .then(response => {
                resolve(this.$notificationV2('deleting', 'toolbox_meeting'));
            })
            .catch(err =>{
                reject(err);
            });
        },
        exportItems() {
            // Handle exporting items
            // Implement export logic (e.g., to CSV, PDF, etc.)
        },

        async getSContracts() {
            if(!this.ClientContractID || !this.ClientContractID.id) {
                this.modals.add.options.scontracts = []
                return
            }
            let tableRequest = {
                filter: { client_contract_id: this.ClientContractID.id },
                page: 1,
                limit: -1
            }

            await this.$store.dispatch("SContractProjectController/getSContract", tableRequest)
                .then(response => {
                    this.modals.add.options.scontracts = response.items;
                })
                .catch(err => {})
        },
        async getEquipments(search = "") {
            if(this.ClientContractID && this.ClientContractID.id) {
                // this.loading.equipment = true;
                this.pagesEquipment.filter['equipment.is_active'] = {  type: 'boolean', value: true }
                this.pagesEquipment.filter.tag_name.value = search;
                this.pagesEquipment.filter.contract_id.value = this.ClientContractID.id;

                await this.$store.dispatch("EquipmentV2Controller/getEquipmentsOfLiftInspectionCalendar", this.pagesEquipment)
                .then(response => {
                    // this.loading.equipment = false;
                    this.modals.add.options.equipments = response.data.data.items;
                })
                .catch(err => {
                    // this.loading.equipment = false;
                    console.log(err)
                })
            }
        },
        async searchContract(search, loading) {
            loading(true)
            this.modals.add.options.scontracts = []
            if (this.timer.scontracts) {
                clearTimeout(this.timer.scontracts);
                this.timer.scontracts = null;
            }
            this.timer.scontracts = setTimeout(async () => {
                try {
                    await this.getSContracts(search);
                    await loading(false)
                } catch(e) {
                    loading(false)
                }
            }, 500);
        },
        async searchEquipment(search, loading) {
            loading(true)
            this.modals.add.options.equipments = []
            if (this.timer.equipment) {
                clearTimeout(this.timer.equipment);
                this.timer.equipment = null;
            }
            this.timer.equipment = setTimeout(async () => {
                try {
                    await this.getEquipments(search);
                    await loading(false)
                } catch(e) {
                    loading(false)
                }
            }, 500);
        },
        loadUser(limit_item, filters = {}) {
            filters.type_user = 'fm_user';
            this.$store
                .dispatch("v2UserController/searchListUser", {
                    limit: limit_item,
                    page: 1,
                    filters: filters,
                    useDatabaseView: true
                })
                .then((response) => {
                    this.modals.add.options.users = response.data;
                })
                .catch((err) => {});
        },
        searchUsers(search, loading) {
            loading(true);
            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }
            this.timer = setTimeout(() => {
                this.loadUser(100, {
                    name: search
                });
                loading(false);
            }, 500);
        },
        async getContractorSupervisors(search = null){
            let filter = {
                user_name:{type:"text",value:search,function:"ilike",with:[]},
                user_email:{type:"text",value:search,function:"ilike",with:[]},
                user_type:{type:"text",value:'Supplier',function:"ilike",with:[]},
                role_name:{type:"text",value:"Contractor Supervisor",function:"ilike",with:[]},
                contract_id:{type:"number",value:this.modals.add.data.project.id,function:"=",with:[]},
            };
            let request = {
                limit: 100,
                page: 1,
                isCMS:1,
                sortColumn:'user_id',
                sortDirection:'ASC',
                filter: filter,
                useDatabaseView:true,
                staff: true
            };
            this.$store.dispatch("UserDutyController/getItems", request)
                .then(result=>{
                    this.modals.add.options.contractor_supervisors = result.items;
                })
                .catch(err => {
                    console.log(err);
                })
        },
        searchContractorSupervisors(search, loading) {
            loading(true);
            if (this.timer.user) {
                clearTimeout(this.timer.user);
                this.timer.user = null;
            }
            this.timer.user = setTimeout(() => {
                this.getContractorSupervisors(100, search);
                loading(false);
            }, 500);
        },
        getTopics(){
            let filter = {reference_type: "Safety Toolbox Meeting Topics"};
            let params = {
                filter: filter,
                limit: -1,
                sortColumn: "id",
                sortDirection: "asc",
            };
            this.$store.dispatch(`ReferenceController/getItems`, params)
                .then(response => {
                    this.modals.add.options.topics = response.items;
                })
        },
        save() {
            if (this.timer.save) {
                clearTimeout(this.timer.save);
                this.timer.save = null;
            }
            this.timer.save = setTimeout(async () => {
                if(!this.modals.add.data.topics) {
                    return this.$alertNotification("Please choose topics.", "danger");
                }
                
                if(!this.modals.add.data.project) {
                    return this.$alertNotification("Please choose a project.", "danger");
                }

                if(!this.modals.add.data.equipment) {
                    return this.$alertNotification("Please choose a equipment.", "danger");
                }

                if(!this.modals.add.data.planned_date) {
                    return this.$alertNotification("Please choose date", "danger");
                }

                if(!this.modals.add.data.start_time) {
                    return this.$alertNotification("Please choose start time", "danger");
                }

                if(!this.modals.add.data.end_time) {
                    return this.$alertNotification("Please choose end time", "danger");
                }

                if(!this.modals.add.data.locations || this.modals.add.data.locations.length === 0) {
                    return this.$alertNotification("Please choose locations", "danger");
                }

                // if(moment(this.modals.add.data.started_date).isAfter(moment(this.modals.add.data.expiry_date))) {
                //     flagDateCheck = true;
                //     message = 'End Date must be greater than Start Date';
                // }

                // const daysDiff = moment(this.modals.add.data.expiry_date).diff(moment(this.modals.add.data.started_date), 'days');
                // if(daysDiff > 6) {
                //     return this.$alertNotification("Start Date and End Date cannot be more than 6 days apart", "danger");
                // }

                if(this.modals.add.loading) return;
                this.modals.add.loading = true;

                let objeClone = {
                    client_contract_id: this.ClientContractID.id,
                    project_id: this.modals.add.data.project.id,
                    location_id: this.modals.add.data.equipment.location_id,
                    location: this.modals.add.data.equipment.location_name,
                    equipment_id: this.modals.add.data.equipment.id,
                    equipment_lift_number: this.modals.add.data.equipment.lift_name,
                    topics: this.modals.add.data.topics,
                    supplier_id: this.modals.add.data.company && this.modals.add.data.company.id ? this.modals.add.data.company.id : null,
                    supplier: this.modals.add.data.company && this.modals.add.data.company.name ? this.modals.add.data.company.name : null,
                    contractor_supervisor_id: this.modals.add.data.contractor_supervisor_by ? this.modals.add.data.contractor_supervisor_by.user_id : null,
                    planned_date: this.modals.add.data.planned_date ? moment(this.modals.add.data.planned_date).format('YYYY-MM-DD') : null,
                    start_time: this.modals.add.data.start_time ? this.modals.add.data.start_time : null,
                    end_time: this.modals.add.data.end_time ? this.modals.add.data.end_time : null,
                    locations: this.modals.add.data.locations ? this.modals.add.data.locations : null
                };
                
                this.$store.dispatch("SafetyAppController/createSafetyToolboxMeetingItem", objeClone)
                .then(async response => {
                    this.modals.add.loading = false;
                    if(response.code && response.message) {
                        this.$alertNotification(response.message, "danger");
                        return;
                    }
                    this.modals.add.open = false;
                    await this.$router.push(`/v2/toolbox-meeting/${response.id}`)
                    await this.$alertNotification(this.$notificationV2('adding', 'toolbox_meeting'), "success");
                })
                .catch(err => {
                    this.modals.add.loading = false;
                    if( err.response.data.error && err.response.data.error.message ) {
                        this.$alertNotification(err.response.data.error.message, "danger"); 
                    }
                })

            }, 200);
        }
    },
    created() {
        // Component lifecycle hook for initialization
    }
}
</script>

<style scoped>
.safety-inspection-checklist {
    padding: 20px;
}
</style>